import { ClearOngoingCallsException } from "@itk/mui-components";
import { actionCreator, ActionReturnType, createGuid } from "@itk/typescript-utils";

export enum Action {
  AddError = "@@ITK:SRC:COMPONENTS:ERROR-VIEWER:ERROR-STORE.TS:ACTION:ADDERROR",
  RemoveError = "@@ITK:SRC:COMPONENTS:ERROR-VIEWER:ERROR-STORE.TS:ACTION:REMOVEERROR"
}

export type ItkError = {
  id: string;
  error: unknown;
};

type ErrorState = {
  errors: ItkError[];
};

const initialState: ErrorState = {
  errors: []
};

export const errorActions = {
  addError: (error: unknown, id: string = createGuid()) => actionCreator(Action.AddError, { error: { error, id } }),
  removeError: (id: string) => actionCreator(Action.RemoveError, { id })
};

export const errorReducer = (state = initialState, action: ActionReturnType<typeof errorActions>): ErrorState => {
  switch (action.type) {
    case Action.AddError:
      if (action.payload.error.error === ClearOngoingCallsException) return state;

      return { ...state, errors: [...state.errors, action.payload.error] };
    case Action.RemoveError:
      return { ...state, errors: state.errors.filter(error => error.id !== action.payload.id) };
    default:
      return state;
  }
};
